export const contractInitialState = {
  amcContractNumber: "",
  contractTypeId: "",
  startDate: "",
  endDate: "",
  civilDefenseContractApprovalStatusId: "",
  amcCopy: "",
  appointmentDates: "",
  engineerTechnicianName: "",
  technicianMobileNumber: "",
  technicianEmail: "",
  technicianAlternateNumber: "",
  managerSupervisorName: "",
  managerMobileNumber:"",
  managerEmail:null,
  managerAlternateNumber:""
};
